"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
class Cursor {
    constructor(elementRef, speed) {
        this.elementRef = elementRef;
        this.handleMouseMove = (e) => {
            this.cursorDestination.x = e.clientX / window.innerWidth;
            this.cursorDestination.y = e.clientY / window.innerHeight;
            if (!this.animationFrameID)
                this.animationFrameID = requestAnimationFrame(this.render);
        };
        this.render = () => {
            const { cursorDestination, cursorGhost, speed, elementRef } = this;
            cursorGhost.x = utils_1.calculatePosition(cursorGhost.x, cursorDestination.x, speed);
            cursorGhost.y = utils_1.calculatePosition(cursorGhost.y, cursorDestination.y, speed);
            elementRef.style.setProperty('--cursor-x', cursorGhost.x.toString());
            elementRef.style.setProperty('--cursor-y', cursorGhost.y.toString());
            if (this.isCursorIdle()) {
                this.handleAnimationFrameCleanup();
                return;
            }
            this.animationFrameID = requestAnimationFrame(this.render);
        };
        this.animationFrameID = null;
        this.cursorDestination = { x: 0.5, y: 0.5 };
        this.cursorGhost = { x: 0.5, y: 0.5 };
        this.speed = speed;
        this.init();
    }
    handleAnimationFrameCleanup() {
        this.animationFrameID && cancelAnimationFrame(this.animationFrameID);
        this.animationFrameID = null;
    }
    isCursorIdle() {
        const cursorTargetDifference = utils_1.calculateDifference(this.cursorGhost, this.cursorDestination);
        return cursorTargetDifference < 0.001;
    }
    init() {
        window.addEventListener('mousemove', this.handleMouseMove);
        this.animationFrameID = requestAnimationFrame(this.render);
    }
    destroy() {
        window.removeEventListener('mousemove', this.handleMouseMove);
    }
}
exports.default = Cursor;
//# sourceMappingURL=index.js.map